import { IconButton, Typography, Box } from '@mui/material'
import {ChevronRight, SupportAgent} from '@mui/icons-material';
import GridLayout from './SupportOptions';
import SupportContactForm from './SupportContactForm';
import { useTranslation } from 'react-i18next';

function SupportCard({handleClose}) {
    const { i18n } = useTranslation();
  return (
    <>
        <IconButton
            onClick={handleClose}
        >
            <ChevronRight sx={{ fontSize: "clamp(1.2vh, 1.2vw, 1.2vw)"}}/>
        </IconButton>
        <Typography sx={{ fontSize: "clamp(1.2vh, 1.2vw, 1.2vw)" }} className='d-flex flex-row align-items-center'>
            <SupportAgent sx={{margin: "8px", fontSize: "clamp(1.2vh, 1.2vw, 1.2vw)"}}/>
            {i18n.t('SUPPORT.CONTACT_SUPPORT')}
        </Typography>
        <hr/>
        <GridLayout handleClose={handleClose}/>
        {/* <hr/> */}
        {/* <Typography sx={{ fontSize: "clamp(1.2vh, 1.2vw, 1.2vw)" }} className='d-flex flex-row align-items-center'>
            {"Submit a Support Ticket"}
        </Typography> */}
        {/* <SupportContactForm/> */}
    </>
  )
}

export default SupportCard  